"use strict";
import {getUser} from "../../services/user";

const state = {
    user: null,
    isLogged: false,
    loading: false,
};

const getters = {
    user: (state) => {
        return state.user;
    },
    accessToken: (state) => {
        return state.user && state.user.accessToken;
    },
    getUserId: (state) => {
        return state.user ? state.user.id : null;
    },
    isLogged: (state) => {
        return state.isLogged;
    },
    loading: (state) => {
        return state.loading;
    },
};

const actions = {
    loadUser({commit, state}) {
        commit('setLoading', true);
        return getUser().then(response => {
            commit('setUser', response.data);
            commit('setLogIn', true);
            commit('setLoading', false);
        }).catch(err => {
            commit('setUser', null);
            commit('setLogIn', false);
            commit('setLoading', false);
        });
    }
};

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setLogIn(state, isLogin) {
        state.isLogged = isLogin
    },
    setLoading(state, loading) {
        state.loading = loading
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js